import { TDispatchFunc, IDispatchToProps } from '../types';

export const multipleMapStateToProps = (
  state: any,
  props: IDispatchToProps,
) => {
  const { opinionMarketingFilter } = state;
  const { valueKeys, instanceId } = props;
  const realValue = opinionMarketingFilter[instanceId as string];
  return {
    ...props,
    value: realValue[valueKeys],
    filterValue: realValue,
  };
};

export const moreKeyMultipleDispatchToProps = (
  dispatch: TDispatchFunc,
  ownProps: IDispatchToProps,
) => {
  const { valueKeys, realTimeMode, instanceId } = ownProps;

  return {
    change: (newValue: Array<string>, isUpdate = false) => {
      dispatch({
        type: 'opinionMarketingFilter/UPDATE_FILTER',
        payload: {
          [valueKeys]: newValue,
          UPDATE: typeof isUpdate === 'boolean' ? isUpdate : false,
        },
        instanceId,
      });
    },
    onClose: () => {
      if (realTimeMode) {
        dispatch({
          type: 'opinionMarketingFilter/UPDATE_FILTER',
          payload: { UPDATE: true },
          instanceId,
        });
      }
    },
  };
};
